module.exports = __webpack_public_path__ + "img/icbc.e1b01700.svg";